<template>
  <DataList
    title="Угоди"
    resource="crm-agreements"
    :columns="columns"
    :get-items-fn="getAgreements"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as agreementsApi from "../../backend/agreementsApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Найменування", name: "title" },
      { title: "Дата", name: "date" },
      { title: "Власник", name: "owner" },
      { title: "Компанія", name: "company" },
      { title: "Сума", name: "amount" },
      { title: "Валюта", name: "currency" },
      { title: "Тип/Стадія воронки", name: "salesFunnel" },
    ],
  }),
  methods: {
    async getAgreements(...args) {
      const entities = await agreementsApi.getAgreements(args[0], args[1], args[2], args[3]);

      entities.result = entities.result.map(entity=>{
        return {
          id: entity.id,
          title: entity.title,
          date: entity.date,
          amount: entity.amount,
          owner: entity.owner != null ? entity.owner.title : "",
          company: entity.company != null ? entity.company.title : "",
          currency: entity.currency != null ? entity.currency.title : "",
          salesFunnel: `${entity.salesFunnelType != null ? entity.salesFunnelType.title : ""}
          ${entity.salesFunnelStage != null ? `/${entity.salesFunnelStage.title}` : ""}`,
        };
      });

      return entities;
    },
  },
};
</script>